export default __webpack_public_path__ + "static/media/elevate-wht-poster-1.04fc630b.jpg";